module.exports = __webpack_public_path__ + "img/laws-4.0ebfad03.jpg";